module.exports = __webpack_public_path__ + "static/media/karnataka.bbd1fd88.png";